import React from 'react';
import { Link } from 'react-router-dom';
import { brandPath, mainSiteHref } from '../utils/brandRouting';
import { RELEASE_LABEL, RELEASE_MANIFEST_PATH, SUPPORT_EMAIL, products } from '../data/siteContent';

const NUTRISCAN = products.find((product) => product.id === 'nutriscan');

export default function NSFooter() {
  const backHref = mainSiteHref();
  return (
    <footer className="ns-footer" data-testid="ns-footer">
      <div className="wrap">
        <div className="ns-footer-brand">Nutri<span>Scan</span></div>
        <p style={{ fontSize: '0.88rem' }}>{NUTRISCAN.description}</p>
        <div className="ns-footer-links">
          <Link to={brandPath('nutriscan', '/privacy')}>Privacy Policy</Link>
          <Link to={brandPath('nutriscan', '/terms')}>Terms of Service</Link>
          <Link to={brandPath('nutriscan', '/faq')}>FAQ</Link>
          <Link to={brandPath('nutriscan', '/account-deletion')}>Account Deletion</Link>
          <a href={`mailto:${SUPPORT_EMAIL}`}>Support</a>
          {backHref ? <a href={backHref}>TickleApps</a> : <Link to="/">TickleApps</Link>}
          <a href={RELEASE_MANIFEST_PATH} data-testid="ns-release-marker">{RELEASE_LABEL}</a>
        </div>
        <p className="ns-footer-copy">&copy; {new Date().getFullYear()} TickleApps. All rights reserved. NutriScan is for informational purposes only and does not constitute medical advice.</p>
      </div>
    </footer>
  );
}
